import { api } from './networkService';

class WalletTransferService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/transaction`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch transaction error:', error);
            throw error;
        }
    }

    static async fetchAll(filters) {
        try {
            const response = await api.get(`api/user/transaction`, {
                params: {
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch transaction error:', error);
            throw error;
        }
    }

    static async add(transaction) {
        try {
            const cleanedTransaction = Object.fromEntries(
                Object.entries(transaction).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/transaction`, cleanedTransaction);
            return response;
        } catch (error) {
            console.error('Add transaction error:', error);
            throw error;
        }
    }

    static async update(transaction) {
        try {
            const { id, ...info } = transaction;
            const cleanedTransaction = Object.fromEntries(
                Object.entries(info).filter(([_, value]) => value && value !== '')
            );

            const response = await api.put(`api/user/transaction/${id}`, cleanedTransaction);
            return response;
        } catch (error) {
            console.error('Update transaction error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/transaction/${id}`);
            return response;
        } catch (error) {
            console.error('Delete transaction error:', error);
            throw error;
        }
    }
}

export default WalletTransferService;
